import axiosInstance from '../config/axios.js';
import { downloadBlob } from '../utils/downloadBlob.js';

const API_BASE = '/shipment-clients';

const shipmentClientService = {
  // Get all shipment clients with optional filters and pagination
  getForBooking: async (hubId) => {
    const response = await axiosInstance.get(`${API_BASE}/booking`, {
      params: hubId ? { hub_id: hubId } : {},
    });
    return response.data;
  },

  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get shipment client by ID
  getById: async (clientId) => {
    const response = await axiosInstance.get(`${API_BASE}/${clientId}`);
    return response.data;
  },

  // Create new shipment client
  create: async (clientData) => {
    const response = await axiosInstance.post(API_BASE, clientData);
    return response.data;
  },

  // Update shipment client
  update: async (clientId, clientData) => {
    const response = await axiosInstance.put(`${API_BASE}/${clientId}`, clientData);
    return response.data;
  },

  // Delete shipment client
  delete: async (clientId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${clientId}`);
    return response.data;
  },

  // Get shipment clients by company name
  getByCompany: async (companyName) => {
    const response = await axiosInstance.get(`${API_BASE}/company/${companyName}`);
    return response.data;
  },

  // Get shipments for a specific client with date filtering
  getClientShipments: async (clientId, params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/${clientId}/shipments`, { params });
    return response.data;
  },

  // Export client shipments to Excel
  exportClientShipments: async (clientId, params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/${clientId}/shipments/export`, {
      params,
      responseType: 'blob' // Important for file download
    });
    
    await downloadBlob(
      response.data,
      `client_${clientId}_shipments_${new Date().toISOString().split('T')[0]}.xlsx`,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    );
    
    return response;
  },

  // Process batch payment for client shipments
  batchPayment: async (clientId, paymentData) => {
    const response = await axiosInstance.post(`${API_BASE}/${clientId}/batch-payment`, paymentData);
    return response.data;
  },

  // Download client invoice PDF
  downloadClientInvoice: async (clientId, params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/${clientId}/invoice/download`, {
      params,
      responseType: 'blob'
    });
    
    await downloadBlob(
      response.data,
      `statement_${clientId}_${new Date().toISOString().split('T')[0]}.pdf`,
      'application/pdf',
    );
    
    return response;
  },

  // Send client invoice via email
  sendClientInvoice: async (clientId, data = {}) => {
    const response = await axiosInstance.post(`${API_BASE}/${clientId}/invoice/send`, data);
    return response.data;
  }
};

export default shipmentClientService;